import React from "react";
import "./ToggleSwitch.scss";

/**
 * A controlled on/off switch, with an optional "On / Off" caption beneath it.
 *
 * @param {Object} props
 * @param {boolean} [props.checked]
 * @param {(next: boolean, event: React.ChangeEvent) => void} [props.onChange]
 *   receives the value being switched TO, not the event target
 * @param {boolean} [props.disabled]   blocks input, e.g. while a request is in flight
 * @param {boolean} [props.showState]  render the "On / Off" caption
 * @param {string} [props.onLabel]
 * @param {string} [props.offLabel]
 * @param {string} [props.ariaLabel]   names the input for screen readers
 * @param {string} [props.className]   appended to the root class
 */
const ToggleSwitch = ({
  checked = false,
  onChange,
  disabled = false,
  showState = false,
  onLabel = "On",
  offLabel = "Off",
  ariaLabel,
  className = "",
}) => (
  <div className={`shared-toggle ${className}`.trim()}>
    <label className="shared-toggle__switch">
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        aria-label={ariaLabel}
        // The next value is what callers actually want; the label wrapping this
        // input has no text, so reading it back off the event is awkward.
        onChange={(event) => onChange?.(!checked, event)}
      />
      <span className="shared-toggle__slider"></span>
    </label>

    {showState ? (
      <span className="shared-toggle__state">
        <b className={checked ? "is-on" : ""}>{onLabel}</b> / {offLabel}
      </span>
    ) : null}
  </div>
);

export default ToggleSwitch;
